const fetchBlob = async (info: RequestInfo, init?: RequestInit) => {
  const response = await fetch(info, init);
  return await response.blob();
};

export default fetchBlob;
